// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"vz_a bhg_b","TwoDimsListFeature__item":"vz_b bhg_wb","TwoDimsListFeature__item__text":"vz_c bhg_vr"};